export var Steps = {
  baseStyle: {
    step: {
      minW: '8rem',
      bg: 'white',
      color: 'black',
      justifyContent: 'center',
      borderBottomColor: 'grey.300',
      px: 6,
      _first: {
        borderTopLeftRadius: 'sm'
      },
      _last: {
        borderTopRightRadius: 'sm'
      },
      _hover: {
        color: 'black'
      },
      _active: {
        bg: 'blue.250',
        color: 'black'
      },
      _focusVisible: {
        boxShadow: '0px 0px 0px 1px #00CAFF, 0px 0px 3px 2px #4CAAF0',
        color: 'black'
      },
      _disabled: {
        _hover: {
          cursor: 'default',
          bg: 'white',
          color: 'black'
        }
      }
    },
    count: {
      backgroundColor: 'blue.275'
    }
  },
  variants: {
    active: {
      step: {
        _hover: {
          bg: 'blue.1140'
        },
        _active: {
          bg: 'grey.250'
        }
      }
    },
    completed: {
      step: {
        color: 'blue.275',
        borderBottomColor: 'currentColor',
        '&:hover, &:active, &:focus-visible': {
          color: 'blue.275'
        }
      }
    }
  }
};